import { ceremonyInfo } from '@/mocks/wedding';

const PANEL_BG =
  'https://readdy.ai/api/search-image?query=Elegant%20classic%20wedding%20hall%20interior%20with%20white%20floral%20arrangements%20and%20soft%20candlelight%2C%20stone%20pillars%20and%20long%20drapes%2C%20warm%20dark%20cinematic%20ambience%2C%20muted%20warm%20brown%20tones&width=2400&height=1350&seq=wed-panel-ceremony&orientation=landscape';

export default function CeremonyPanel() {
  return (
    <section className="panel" data-side="right" id="ceremony">
      <img className="panel-bg" src={PANEL_BG} alt="촛불과 흰 꽃으로 장식된 예식장 내부" data-parallax="0.32" />
      <div className="panel-veil" aria-hidden="true" />
      <div className="panel-copy" data-parallax="-0.08">
        <p className="stamp" data-reveal>
          03 — 예식 정보
        </p>
        <h2 data-reveal>
          예식의 모든 안내를
          <br />
          <em className="accent">한 자리에</em>
        </h2>
        <p className="sub" data-reveal>
          오시는 길과 주차, 예식 시간을 미리 확인해 주세요. 편안한 마음으로 오실 수 있도록 정성껏
          준비했습니다.
        </p>
        <ul className="info-list">
          {ceremonyInfo.map((row) => (
            <li key={row.label} data-reveal>
              <span>{row.label}</span>
              <span>{row.value}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}